// frontend/src/main.tsx
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { ChurchProvider } from './context/ChurchContext.tsx'; // Import ChurchProvider

import { ToastProvider } from './context/ToastContext.tsx'; // Import ChurchProvider
import { AuthProvider } from './context/AuthContext.tsx'; // Import AuthProvider
import { BrowserRouter as Router } from 'react-router-dom';
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://aa92dbdea43cf6182ee21f377bc74c20@o4509666172731392.ingest.de.sentry.io/4509666307145808",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration()
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", import.meta.env.VITE_API_BASE_URL],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});


ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
  <Router>
    {/* Wrap the App component with ChurchProvider */}
    {/* We'll pass the identifier from App.tsx, but eventually this would be dynamic (e.g., from URL) */}
    <AuthProvider>
    <ChurchProvider initialChurchIdentifier={import.meta.env.VITE_DEV_CHURCH_IDENTIFIER}>
      <ToastProvider>
      <App />
      </ToastProvider>
    </ChurchProvider>

    </AuthProvider>
    </Router>
  </React.StrictMode>,
)
